import React from "react";
import { Box, Typography, alpha } from "@mui/material";
/** Card shell shared by the chart and the log tables (Figma: Card + CardHeader). */
export const NodeLogCard = ({ title, actions, children, }) => (React.createElement(Box, { sx: {
        display: "flex",
        flexDirection: "column",
        minWidth: 0,
        borderRadius: "32px",
        backgroundColor: "background.paper",
        // Inset ring instead of a border so the stroke never shifts the content.
        boxShadow: (theme) => `inset 0 0 0 1px ${theme.palette.grey[300]}`,
    } },
    React.createElement(Box, { sx: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            minHeight: 68,
            px: "20px",
            py: { xs: 1, md: 0 },
        } },
        React.createElement(Typography, { variant: "h6", component: "h2", noWrap: true, sx: { minWidth: 0 } }, title),
        actions),
    React.createElement(Box, { sx: { px: "20px", pb: 2 } }, children)));
export const LOG_CARD_INNER_BORDER = (theme) => `inset 0 0 0 1px ${alpha(theme.palette.grey[500], 0.12)}`;
